// Skip https://github.com/google/code-prettify that is served by https://github.com/MiniProfiler/rack-mini-profiler.
//
// By defining `prettyPrint` function we skip further code loading here:
// https://github.com/MiniProfiler/rack-mini-profiler/blob/042d91e29c385d5d95af4fd6bbb0f2c49f2f81fb/lib/html/includes.js#L1055
window.prettyPrint = function prettyPrint() {}
